/**
 * jQuery-File-Uploadのメッセージ管理を行う.
 *
 * @author Shimamoto_koi@ogis-ri.co.jp
 *
 */
switch ($('html').attr('lang')) {
  case 'ja':
    $.widget('blueimp.fileupload', $.blueimp.fileupload, {
      options: {
        messages: {
          maxNumberOfFiles: '最大送信可能ファイル数を超えています。',
          acceptFileTypes: '不正なファイル形式です。',
          maxFileSize: '最大ファイルサイズを超えています。',
          minFileSize: 'ファイルサイズが小さすぎます。',
        },
      },
    })
    break
  case 'zh':
    $.widget('blueimp.fileupload', $.blueimp.fileupload, {
      options: {
        messages: {
          maxNumberOfFiles: '文件数大于限制。',
          acceptFileTypes: '文件格式不匹配。',
          maxFileSize: '文件大小大于限制。',
          minFileSize: '文件大小小于限制。',
        },
      },
    })
    break
  default:
    $.widget('blueimp.fileupload', $.blueimp.fileupload, {
      options: {
        messages: {
          maxNumberOfFiles: 'exceeds max number of files.',
          acceptFileTypes: 'invalid file type.',
          maxFileSize: 'exceeds max file size.',
          minFileSize: 'file size is too small.',
        },
      },
    })
}
